<app-dialog [size]="DialogSize.SMALL">
  <app-dialog-header>
    Update billing address
  </app-dialog-header>

  <app-stripe-address-element [billingDetails]="data.paymentMethod.billingDetails" [forceVisible]="true"></app-stripe-address-element>

  <app-dialog-footer>
    <button
      andButton
      color="primary"
      [isLoading]="isSaveLoading$ | async"
      (click)="save()"
      data-cy="update-billing-address-save-button"
    >
      Save
    </button>
  </app-dialog-footer>
</app-dialog>
